import { create } from "zustand";

const useStore = create((set) => ({
  departments: [],
  patient : null,
  providers: [],
  provider: null,
  departmentprovider: [],
  appointmentTypes: [],
  appointmentReason: [],
  selectedDepartment: "",
  selectedProvider: "",
  selectedType: "",
  appointmentDetails : {},
  insuranceDetails : {},
  appointmentFormData: null,
  isNewPatient: true,
  // Consultation state
  consultationSubmissions: [],
  consultationFilters: {},
  actions: {
    setAppointmentFormData: (data) => set({ appointmentFormData: data }),
    setDepartments: (departments) => set((state) => ({ ...state, departments })),
    setProviders: (providers) => set((state) => ({ ...state, providers })),
    setProvider: (provider) => set((state) => ({ ...state, provider })),
    setDepartmentProvider: (departmentprovider) => set((state) => ({  departmentprovider })),
    setAppointmentTypes: (appointmentTypes) => set((state) => ({ ...state, appointmentTypes })),
    setAppointmentReason: (appointmentReason) => set((state) => ({ ...state, appointmentReason })),
    setSelectedDepartment: (selectedDepartment) => set((state) => ({ ...state, selectedDepartment })),
    setSelectedProvider: (selectedProvider) => set((state) => ({ ...state, selectedProvider })),
    setSelectedType: (selectedType) => set((state) => ({ ...state, selectedType })),
    setPatient: (patient) => set((state) => ({ ...state, patient })),
    setIsNewPatient: (isNewPatient) => set((state) => ({ ...state, isNewPatient })),
    setAppointmentDetails: (appointmentDetail) => set((state) => ({
      appointmentDetails: {
        ...state.appointmentDetails,
        ...appointmentDetail
      }
    })),
    setInsuranceDetails: (insuranceDetail) => set((state) => ({
      insuranceDetails: {
        ...state.insuranceDetails,
        ...insuranceDetail
      }
    })),
    setConsultationSubmissions: (data) => set({ consultationSubmissions: data }),
    setConsultationFilters: (filters) => set({ consultationFilters: filters })
    
  },
}));

export default useStore;
export const useStoreActions = () => useStore((state) => state.actions);
